import { action, makeObservable, observable, runInAction } from "mobx";
import StockIssueRequestAPI from "../api/StockIssueRequestAPI";
import { StockIssueRequest } from "../models/StockIssueRequest/StockIssueRequest";
import { StockIssueRequestFilters } from "../models/StockIssueRequest/StockIssueRequestFilters";

export class StockIssueRequestStore {
  api: StockIssueRequestAPI;
  stockIssueRequests: StockIssueRequest[] = [];
  currentRequest: StockIssueRequest | null = null;
  total_count: number = 0;
  total_pages: number = 0;
  limit: number = 30;

  constructor() {
    this.api = new StockIssueRequestAPI();
    this.stockIssueRequests = [];
    this.currentRequest = null;
    this.total_count = 0;
    this.total_pages = 0;
    this.limit = 30;

    makeObservable(this, {
      stockIssueRequests: observable,
      currentRequest: observable,
      total_count: observable,
      total_pages: observable,
      limit: observable,
      getStockIssueRequests: action,
      getStockIssueRequestById: action,
    });
  }

  getStockIssueRequestById = async (id: number): Promise<void> => {
    try {
      const response = await this.api.getStockIssueRequestById(id);
      runInAction(() => {
        this.currentRequest = response;
      });
    } catch (error) {
      runInAction(() => {
        this.currentRequest = null;
      });
      console.error("Failed to fetch stock issue request by id:", error);
    }
  };

  getStockIssueRequests = async (
    filters: StockIssueRequestFilters,
  ): Promise<void> => {
    try {
      const response = await this.api.getStockIssueRequests(filters);
      runInAction(() => {
        this.stockIssueRequests = response.list ?? [];
        this.total_count = response.total_count ?? 0;
        this.total_pages = response.total_pages ?? 0;
        this.limit = response.limit ?? 30;
      });
    } catch (error) {
      runInAction(() => {
        this.stockIssueRequests = [];
        this.total_count = 0;
        this.total_pages = 0;
        this.limit = 30;
      });
      console.error("Failed to fetch stock issue requests:", error);
    }
  };
}
